import {ssoConfigGlobal} from './../../../config/sso_conf_global'
import {ssoConfigLocal} from '../../../static/local_config/sso_conf_local.js'
import {StoritevVrstaEnum} from '../../assets/js/Enum/StoritevVrstaEnum.js'

let configSSO = ssoConfigGlobal.constructor()
for (let attr in ssoConfigGlobal) {
  if (ssoConfigGlobal.hasOwnProperty(attr)) {
    configSSO[attr] = ssoConfigGlobal[attr]
  }
}
for (let lastnost2 in ssoConfigLocal) {
  configSSO[lastnost2] = ssoConfigLocal[lastnost2]
}

configSSO['AUTH0_CLIENT_ID'] = process.env.AUTH0_CLIENT_ID
configSSO['PICTURE_URL'] = process.env.PICTURE_URL
configSSO['AUTH0_DOMAIN'] = process.env.AUTH0_DOMAIN
configSSO['AUTH0_RESPONSE_TYPE'] = process.env.AUTH0_RESPONSE_TYPE
configSSO['AUTH0_SCOPE'] = process.env.AUTH0_SCOPE

let storitevVrsta = StoritevVrstaEnum.constructor()
for (let lastnost in StoritevVrstaEnum) {
  storitevVrsta[lastnost] = StoritevVrstaEnum[lastnost]
}

let configRecaptcha = {
  siteKeyV3: process.env.RECAPTCHA_SITE_KEY_V3,
  siteKeyV2: process.env.RECAPTCHA_SITE_KEY_V2,
  url: process.env.RECAPTCHA_URL
}

export {configSSO, storitevVrsta, configRecaptcha}



// WEBPACK FOOTER //
// ./src/assets/js/config.js